// Arranca la preparación de texturas en cuanto se carga la página (antes de que llegue three.js) y guarda los resultados
// hasta que la escena los pida. Worker + OffscreenCanvas si existe; si no, el mismo cálculo en el hilo principal.
import { PROCEDURAL, RAW, plan, runJobs } from './texjobs.js';

export function startTextures({ base, lite, onLoaded = () => {} }) {
  const keys = [...PROCEDURAL, ...Object.keys(RAW)]; for (const j of plan(lite)) { if (j.base) keys.push(j.base); for (const d of j.derived || []) keys.push(d.key); }
  const deferreds = new Map(keys.map(k => { let res, rej; const p = new Promise((a, b) => { res = a; rej = b; }); p.catch(() => {}); return [k, { p, res, rej }]; }));
  const emit = (key, src, flipY) => { const d = deferreds.get(key); if (d) d.res({ src, flipY }); };
  const fail = (msg) => { const err = new Error(msg); deferreds.forEach(d => d.rej(err)); };
  const absBase = new URL(base, location.href).href, root = new URL('./', location.href).href;
  let usedFallback = false;
  const fallback = () => {
    if (usedFallback) return; usedFallback = true;
    const mk = (w, h) => { const c = document.createElement('canvas'); c.width = w; c.height = h; return c; };
    runJobs({ base: absBase, root, lite, mk,
      finish: async (src, photo) => { if (!photo) return src; const c = mk(src.width, src.height); c.getContext('2d').drawImage(src, 0, 0); if (src.close) src.close(); return c; },
      emit: (k, s) => emit(k, s, true), loaded: onLoaded, fail });
  };
  try {
    if (typeof OffscreenCanvas === 'undefined' || !('createImageBitmap' in window)) throw new Error('sin OffscreenCanvas');
    const worker = new Worker(new URL(__TEX_WORKER__, import.meta.url), { type: 'module' });
    worker.onmessage = ({ data }) => {
      if (data.loaded) onLoaded(data.loaded);
      else if (data.key) emit(data.key, data.bmp, false);
      else if (data.error) fail(data.error);
      else if (data.done) worker.terminate();
    };
    worker.onerror = (e) => { e.preventDefault(); worker.terminate(); fallback(); };
    worker.postMessage({ base: absBase, root, lite });
  } catch { fallback(); }
  return { get: (key) => deferreds.get(key).p, keys };
}
